module.exports = __webpack_public_path__ + "marine_park.2d98042f573631bdb1010a5967a7e96b.png";